import React from "react";
import { Drawer, DrawerProps, Button, Popconfirm } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

interface IDrawerProps extends DrawerProps {
  title?: string;
  icon?: JSX.Element;
  children: any;
  formId?: number;
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  confirmbuttontxt?: string;
  customrendercancelbutton?: JSX.Element;
  disabled: boolean;
  isLoading?: boolean;
  popConfirm?: boolean;
  onConfirm?: (ev?: React.MouseEvent<HTMLElement>) => void;
  setShowConfirmDisableReader: (ev) => void;
  onCheckForm: (ev?: React.MouseEvent<HTMLElement>) => void;
}

interface IFooterProps {
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  confirmbuttontxt?: string;
  customrendercancelbutton?: JSX.Element;
  disabled?: boolean;
  formId?: number;
  popConfirm?: boolean;
  isLoading?: boolean;
  onConfirm?: (ev?: React.MouseEvent<HTMLElement>) => void;
  onClose: (ev: React.MouseEvent<HTMLElement>) => void;
  setShowConfirmDisableReader: (ev) => void;
  onCheckForm: (ev?: React.MouseEvent<HTMLElement>) => void;
}

const Footer = (props: IFooterProps) => {
  const NO = useTranslation({ id: "no" });
  const YES = useTranslation({ id: "yes" });
  const SAVE = useTranslation({ id: "save" });
  const THERE_ARE_ACTIVE_ANTENNAS = useTranslation({ id: "there_are_active_antennas_linked_to_this_reader_do_you_wish_to_deactivate_this_reader" });

  return (
    <S.DrawerFooter>
      <div className="left">
        {props.showCancelButton && !props.customrendercancelbutton && (
          <Button onClick={props.onClose} className="btnCancel" disabled={props.disabled || props.isLoading}>
            {props.cancelbuttontxt}
          </Button>
        )}
        {props.customrendercancelbutton !== null && props.customrendercancelbutton}
      </div>
      <div className="right">
        <Popconfirm
          open={props.popConfirm}
          title={THERE_ARE_ACTIVE_ANTENNAS}
          placement="left"
          okText={YES}
          cancelText={NO}
          onConfirm={(e) => {
            props.onConfirm(e);
            props.setShowConfirmDisableReader(false);
          }}
          onCancel={() => props.setShowConfirmDisableReader(false)}
        >
          <Button type="primary" onClick={props.onCheckForm} className="btn" disabled={props.disabled || props.isLoading} loading={props.disabled || props.isLoading}>
            {props.formId ? SAVE : props.confirmbuttontxt}
          </Button>
        </Popconfirm>
      </div>
    </S.DrawerFooter>
  );
};

Footer.defaultProps = {
  cancelbuttontxt: "cancel",
  showCancelButton: true,
  confirmbuttontxt: "Ok",
  disabled: false,
  popConfirm: false,
  isLoading: false,
};

const Title = ({ label }) => {
  return <S.Title>{label}</S.Title>;
};

const ReaderDrawer = (props: IDrawerProps) => {
  return (
    <Drawer
      {...props}
      title={<Title label={props.title} />}
      footer={
        <Footer
          cancelbuttontxt={props.cancelbuttontxt}
          showCancelButton={props.showCancelButton}
          onClose={props.onClose}
          confirmbuttontxt={props.confirmbuttontxt}
          onConfirm={props.onConfirm}
          customrendercancelbutton={props.customrendercancelbutton}
          disabled={props.disabled}
          popConfirm={props.popConfirm}
          setShowConfirmDisableReader={props.setShowConfirmDisableReader}
          onCheckForm={props.onCheckForm}
          isLoading={props.isLoading}
          formId={props.formId}
        />
      }
    >
      {props.children}
    </Drawer>
  );
};

ReaderDrawer.defaultProps = {
  title: "Configuration",
};

export default ReaderDrawer;
